import { Controller } from '@hotwired/stimulus';

const GAP_CLASS = 'comment-input-container--spacer';

export default class extends Controller {
  static targets = ['input', 'submitWrapper', 'submitButton', 'container'];

  connect() {
    this.initializeState();
  }

  showSubmit() {
    this.submitWrapperTarget.classList.remove('hidden');
    this.removeGap();
    this.updateButtonState();
  }

  handleInput() {
    this.showSubmit();
    this.updateButtonState();
  }

  hideSubmitIfEmpty() {
    if (this.inputIsBlank()) {
      this.submitWrapperTarget.classList.add('hidden');
      this.addGap();
    }
    this.updateButtonState();
  }

  initializeState() {
    if (this.inputIsBlank()) {
      this.submitWrapperTarget.classList.add('hidden');
      this.addGap();
    } else {
      this.submitWrapperTarget.classList.remove('hidden');
      this.removeGap();
    }

    this.updateButtonState();
  }

  updateButtonState() {
    const disable = this.inputIsBlank();

    if (disable) {
      this.submitButtonTarget.setAttribute('disabled', 'disabled');
      this.submitButtonTarget.setAttribute('aria-disabled', 'true');
      this.submitButtonTarget.disabled = true;
    } else {
      this.submitButtonTarget.removeAttribute('disabled');
      this.submitButtonTarget.setAttribute('aria-disabled', 'false');
      this.submitButtonTarget.disabled = false;
    }
  }

  inputIsBlank() {
    return !this.inputTarget.value || this.inputTarget.value.trim().length === 0;
  }

  addGap() {
    this.containerTarget.classList.add(GAP_CLASS);
  }

  removeGap() {
    this.containerTarget.classList.remove(GAP_CLASS);
  }

  cancel(event) {
    event?.preventDefault?.();

    // Reset hidden input (TipTap sync source)
    this.inputTarget.value = '';
    this.inputTarget.dispatchEvent(new Event('input', { bubbles: true }));
    this.inputTarget.dispatchEvent(new Event('change', { bubbles: true }));

    // Ask the React TipTap instance (if present) to clear itself too
    window.dispatchEvent(new CustomEvent('comment:cancel', { detail: { hiddenInputId: this.inputTarget.id } }));

    // Reset submit state + spacing
    this.hideSubmitIfEmpty();

    // Close comments panel (matches overlay / close button behavior)
    document.body.classList.remove('comment-section-open');
  }
}
